import { render, staticRenderFns } from "./InvalidIntegration.vue?vue&type=template&id=c912486c&scoped=true&"
import script from "./InvalidIntegration.vue?vue&type=script&lang=js&"
export * from "./InvalidIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c912486c",
  null
  
)

export default component.exports